import { api, ui, utils } from "services";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Popup } from "semantic-ui-react";
import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { AuthEntity, AuthInterface, LoginType, Size } from 'interfaces';
import { RootState } from 'reducer/store';
import { useTranslation } from 'react-i18next';
import { setLoginType } from "reducer/logintype.slice";
import { removeAuthInfo } from "reducer/wallet.slice";
import ChangePasswordPopup from "page/account/change-password";
import CustomButton from "components/button";

export const EmailCard = ({
    data,
    size,
    className,
    type
}: {
    data: AuthEntity,
    size: Size,
    className?: string,
    type: LoginType
}) => {
    const [isCopied, setIsCopied] = useState(false);
    const dispatch = useDispatch();
    const wallets = useSelector((state: RootState) => state.wallets);
    const { t } = useTranslation();
    const [changePassword, setChangePassword] = useState(false);


    const connectExtension = async (email: string) => {
        try {
            await api.requestLinkEmail(email);
            ui.alertSuccess("Request link email", 'Check your email to continue !')
        } catch (err: any) {
            ui.alertFailed("Request link email", t(err.message))
        }
    }
    const disconnectExtension = async () => {
        try {
            let availableAuths = utils.getAvailableAuths(wallets, type);
            await api.unlinkWallet(data[AuthInterface.identity], type)
            ui.alertSuccess(`Disconnect ${LoginType[type]} successful !`, "");
            dispatch(removeAuthInfo({ type }))
            dispatch(setLoginType(availableAuths[0]))
        } catch (err: any) {
            ui.alertFailed(`Disconnect ${LoginType[type]} failed !`, t(err.message));
        }
    }

    switch (size) {
        case Size.Big:
            return (
                <div className={`${className} w-full rounded-lg`}
                    style={{
                        background: `url("/assets/images/wallets/email-wallet.png")`,
                        backgroundRepeat: "no-repeat",
                        position: "relative",
                        backgroundSize: "cover",
                        minHeight: "180px",
                        backgroundPosition: "bottom right"
                    }}
                >
                    <ChangePasswordPopup
                        open={changePassword}
                        onClose={() => {
                            setChangePassword(false);
                        }}
                    />
                    <div className="h-36 md:h-28 p-4 px-6">
                        <div className="flex justify-between">
                            <div>{LoginType[type].toString()}</div>
                            <div className="flex float-right">
                                <Popup position="bottom center"
                                    content={isCopied ? "Copied" : data[AuthInterface.identity]}
                                    onClose={() => setIsCopied(false)}
                                    disabled={!data[AuthInterface.identity]}
                                    trigger={
                                        <CopyToClipboard
                                            text={data[AuthInterface.identity]}
                                            onCopy={() => {
                                                setIsCopied(true)
                                            }}
                                        >
                                            <img
                                                src="/assets/images/icons/copy-icon.svg" alt="copy"
                                                className="h-6 w-6 cursor-pointer" />
                                        </CopyToClipboard>
                                    } />
                                <Popup
                                    position="bottom center" content={data[AuthInterface.identity] ?
                                        `Unlink ${LoginType[type]}` : `Attach ${LoginType[type]}`}
                                    disabled={!data[AuthInterface.identity]}
                                    trigger={
                                        data[AuthInterface.identity] ? <img
                                            src={`/assets/images/icons/link-wallet-icon.svg`}
                                            alt="wallet-icon"
                                            className="h-6 w-6 ml-2 cursor-pointer"
                                            onClick={disconnectExtension}
                                        /> :
                                            <>
                                                <img
                                                    src={`/assets/images/icons/unlink-wallet-icon.svg`}
                                                    alt="wallet-icon"
                                                    className="h-6 w-6 ml-2 cursor-pointer"
                                                    onClick={
                                                        () => ui.openTextForm('Connect to email', connectExtension, 'Email', 'email')
                                                    }
                                                />
                                            </>
                                    }>
                                </Popup>
                            </div>
                        </div>
                        <p className="font-normal mt-2 text-white-light text-lg">
                            {LoginType[type].toString()} id: {" "}
                            {utils.displayWalletAddress(data[AuthInterface.identity])}
                        </p>
                        <div className="block my-2 bottom-8 absolute">
                            <div className="font-medium text-md">
                                <CustomButton
                                    className="px-3"
                                    disabled={!data[AuthInterface.identity]}
                                    color="orange"
                                    onClick={() => {
                                        setChangePassword(true);
                                    }}
                                >
                                    Change password
                                </CustomButton>
                            </div>
                        </div>
                    </div>
                </div >
            )

        case Size.Small:
            return (
                <></>
            )
    }
}
